/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Featured1Inputs */

const vi_cmspost_featured1 = /** @type {(inputs: Cmspost_Featured1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nổi bật (hiện ở trang chủ)`)
};

/**

* @param {Cmspost_Featured1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_featured1 = /** @type {((inputs?: Cmspost_Featured1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Featured1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_featured1(inputs)
});
export { cmspost_featured1 as "cmsPost_featured" }